export const SOURCES = [
    "AI",
    // "AitFR-AVT",
    "EGW",
    "FTD",
    // "GGR",
    // "LLK",
    "PHB",
    "SCC",
    "TCE",
    "XGE"
];